const BACKEND_URL = 'https://vantage-production-4475.up.railway.app';

export const callObsidianAI = async (messages, system, maxTokens = 2000) => {
  const response = await fetch(`${BACKEND_URL}/api/obsidian/chat`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({
      messages,
      system,
      max_tokens: maxTokens
    })
  });
  const data = await response.json();
  if (!data.success) throw new Error(data.message);
  return { content: data.data.content };
};